export default __webpack_public_path__ + "static/media/rating.7b069863.svg";